import { useSelector } from "react-redux";


export function useUserInfo() {
    const userInfo = useSelector(state => state.auth.userInfo) || {}

    // const [isOnline, setIsOnline] = useState(null);
  
    // ...
  
    return {
        isAuthenticated: userInfo.isAuthenticated,
        userName: userInfo.userName,
        email: userInfo.email,
        role: userInfo.role,
        permissions: userInfo.permissions
    };
  }